import { Button } from '@material-ui/core';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import { Link } from 'gatsby';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Controller, Scene } from 'react-scrollmagic';

import { CONTACT_US_PAGE } from '../../links';
import PlanItem from './plan-item';
import SectionTitle from './section-title';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(6, 0),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(0, 0, 23)
    }
  },
  animate: {
    position: 'relative',
    top: 20,
    transition:
      'opacity 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955), top 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955)',
    opacity: 0
  },
  show: {
    top: 0,
    opacity: 1
  },
  title: {
    marginBottom: theme.spacing(6),
    transitionDelay: '0.1s',
    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing(4)
    }
  },
  descr: {
    marginBottom: theme.spacing(14),
    transitionDelay: '0.3s'
  },
  customeContent: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(2, 0),
    [theme.breakpoints.up('md')]: {
      flexDirection: 'column',
      height: '100%',
      padding: 0
    }
  },
  customeLink: {
    width: '100%',
    textDecoration: 'none',
    [theme.breakpoints.up('lg')]: {
      minWidth: 266,
      width: 'auto'
    }
  },
  d0: {
    transitionDelay: '0.6s'
  },
  d1: {
    transitionDelay: '0.9s'
  },
  d2: {
    transitionDelay: '1.2s'
  }
}));

const plansData = {
  business: {
    name: 'Business',
    color: '#02BBD3',
    price: '$149',
    period: '/month',
    numberViews: '1500',
    nubmerExperiences: 'Unlimited',
    mostPopular: false
  },
  businessPro: {
    name: 'Business Pro',
    color: '#6FCF97',
    price: '$319',
    period: '/month',
    numberViews: '2500',
    nubmerExperiences: 'Unlimited',
    mostPopular: true
  },
  custome: {
    name: 'Custom',
    color: '#0B2027',
    price: 'By request',
    period: '',
    numberViews: '',
    nubmerExperiences: '',
    mostPopular: false
  }
};

const PlansContent = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <section className={classes.root}>
      <Container maxWidth="xl">
        <Controller>
          <Scene
            classToggle={[`.${classes.animate}`, `${classes.show}`]}
            triggerElement="#whiteLabelPlans"
            indicators={false}
            reverse={false}
            offset="-200px"
          >
            <div id="whiteLabelPlans">
              <SectionTitle
                className={clsx(classes.title, classes.animate)}
                title={t('whiteLabelPage.plans.title')}
              />
              <Typography
                className={clsx(classes.descr, classes.animate)}
                variant="body1"
                align="center"
              >
                {t('whiteLabelPage.plans.descr')}
              </Typography>
              <Grid container spacing={10}>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  className={clsx(classes.d0, classes.animate)}
                >
                  <PlanItem data={plansData.business} />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  className={clsx(classes.d1, classes.animate)}
                >
                  <PlanItem data={plansData.businessPro} />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  className={clsx(classes.d2, classes.animate)}
                >
                  <PlanItem data={plansData.custome}>
                    <div className={classes.customeContent}>
                      <Link
                        className={classes.customeLink}
                        to={CONTACT_US_PAGE}
                      >
                        <Button variant="contained" color="primary" fullWidth>
                          {t('whiteLabelPage.plans.link')}
                        </Button>
                      </Link>
                    </div>
                  </PlanItem>
                </Grid>
              </Grid>
            </div>
          </Scene>
        </Controller>
      </Container>
    </section>
  );
};

export default PlansContent;
